import React, { Component, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from '@material-ui/core/Card';
import Col from 'react-bootstrap/Col';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useForm } from "react-hook-form";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import library from './Icons';
import Image from 'react-bootstrap/Image'
import logo from './logo512.PNG';
import { yupResolver } from '@hookform/resolvers';
import * as yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
//  TODO:   Check this out! https://levelup.gitconnected.com/lazy-loading-images-in-react-for-better-performance-5df73654ea05

const schema = yup.object().shape({
    username: yup.string().required(),
    password: yup.string().required()
});

const useStyles = makeStyles((theme) => ({
    selectable: {
        cursor: "pointer"
    },
    colorBlue: {
        color: "blue"
    },
    root: {
        display: 'flex',
        marginBottom: "10px",
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        }
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    button: {
        backgroundColor: "black",
        color: "white"
    }
}));

export default function Login(props) {
    const { register, handleSubmit, watch, errors } = useForm({
        resolver: yupResolver(schema)
    });
    const onSubmit = data => {
        props.login(data);
        //toast.dark("Coming soon!");
    };
    const classes = useStyles();

    useEffect(() => {
        document.title = "Pupitres | Inicio de Sesión";
    });

    return (
        <Row className="justify-content-center card-shadow" style={{ padding: "2rem", backgroundColor: "rgba(255, 255, 255, 0.5)", paddingTop:"0px" }}>
            <Col>
                <form id="loginForm" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <Row className="justify-content-center">
                        <Col style={{ width:"10rem", maxWidth:"10rem" }}>
                            <Image src={logo} fluid />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <TextField
                                error={errors.username}
                                name="username"
                                id="filled-error-helper-text"
                                label="Usuario o Correo"
                                defaultValue=""
                                helperText={errors.username ? "Este campo es obligatorio" : ""}
                                variant="filled"
                                inputRef={register}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <TextField
                                error={errors.password}
                                name="password"
                                id="filled-error-helper-text"
                                type="password"
                                label="Contraseña"
                                defaultValue=""
                                helperText={errors.password ? "Este campo es obligatorio" : ""}
                                variant="filled"
                                inputRef={register}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-end" style={{textAlign:"right"}}>
                        <Col>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                endIcon={<FontAwesomeIcon icon={"sign-in-alt"} />}
                                type="submit"
                                form="loginForm"
                            >
                                Ingresar
                            </Button>
                        </Col>
                    </Row>
                </form>
            </Col>
        </Row>
    )
}